import { Controller, Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Switch } from "keep-react";
import { RegisterFormData } from "../schema";
import { useSelector } from "react-redux";
import { 
  selectBrandString, 
  selectPrivacyLink, 
  selectTermsLink, 
  selectLoyaltyLink 
} from "@store/features/styleSchemaSlice";

interface TermsSectionProps {
  control: Control<RegisterFormData>;
  marketingAccepted: boolean;
  privacyAccepted: boolean;
  handleTermsToggle: (checked: boolean) => void;
  handlePrivacyToggle: (checked: boolean) => void;
  errors: any;
}

export const TermsSection = ({
  control,
  handleTermsToggle,
  handlePrivacyToggle,
  errors,
}: TermsSectionProps) => {
  const { t } = useTranslation();
  const brandString = useSelector(selectBrandString);
  
  // Verwende die brandspezifischen Links aus den Redux-Selektoren
  const privacyUrl = useSelector(selectPrivacyLink);
  const termsUrl = useSelector(selectTermsLink);
  const loyaltyUrl = useSelector(selectLoyaltyLink);

  const marketingText = t("register.marketing.label", {
    privacyLink: `<a class="text-[var(--accent-color)] hover:underline" href="${loyaltyUrl}" target="_blank">`,
    "/privacyLink": "</a>",
  });

  const termsText = t("register.terms.label", {
    termsLink: `<a class="text-[var(--accent-color)] hover:underline" href="${termsUrl}" target="_blank">`,
    "/termsLink": "</a>",
    privacyLink: `<a class="text-[var(--accent-color)] hover:underline" href="${privacyUrl}" target="_blank">`,
    "/privacyLink": "</a>",
    brandString
  });

  return (
    <div className="space-y-3 mt-6">
      <div className="flex flex-col">
        <div className="flex items-center gap-4">
          <Controller
            name="marketingAccepted"
            control={control}
            render={({ field }) => (
              <div>
                <Switch
                  checked={field.value}
                  onCheckedChange={(checked) => {
                    handleTermsToggle(checked);
                  }}
                  className="bg-primary"
                />
              </div>
            )}
          />
          <p
            className="flex-1 text-sm font-medium text-gray-700"
            dangerouslySetInnerHTML={{ __html: marketingText }}
          />
        </div>
      </div>

      <div className="flex flex-col">
        <div className="flex items-center gap-4">
          <Controller
            name="privacyAccepted"
            control={control}
            render={({ field }) => (
              <div>
                <Switch
                  checked={field.value}
                  onCheckedChange={(checked) => {
                    handlePrivacyToggle(checked);
                  }}
                  className="bg-primary"
                />
              </div>
            )}
          />
          <div className="flex items-start">
            <span className="text-red-500">*</span>
            <p
              className="flex-1 text-sm font-medium text-gray-700"
              dangerouslySetInnerHTML={{ __html: termsText }}
            />
          </div>
        </div>
        {errors.privacyAccepted && (
          <p className="text-red-500 text-xs mt-1">
            {errors.privacyAccepted.message}
          </p>
        )}
      </div>
    </div>
  );
};